const backendPrefix = '/api/catalog/';
const frontendPrefix = '/cat/';

const cats = [
  'orgs', 'budgets', 'industries', 'kdbs', 'payers', 'paymentskins', 'accounts',
  'regions', 'provinces', 'landcategories', 'inflationindex', 'kveds',
  'zones', 'salaries', 'localities', 'specialpurpose',
  'districts', 'areas', 'streets', 'houses', 'stateproperties', 'budgetaryinstitutions',
];

/**
 * Тип описывающий справочник
 * @typedef {Object} CatDef
 * @property {string} backend
 * @property {string} frontend
 * @property {func} lister
 * @property {func} selector
 */

/**
 * @const
 * @type {object}
 * @property {CatDef} orgs
 * @property {CatDef} budgets
 * @property {CatDef} contracts
 * @property {CatDef} industries
 * @property {CatDef} kdbs
 * @property {CatDef} payers
 * @property {CatDef} paymentskins
 * @property {CatDef} accounts
 */
export const catalogs = cats.reduce(
  (R, cat) => ({
    ...R,
    [cat]: {
      backend: `${backendPrefix}${cat}/`,
      frontend: `${frontendPrefix}${cat}/`,
    },
  }),
  {
    markers: {
      backend: '/api/markers/',
      frontend: `${frontendPrefix}markers/`,
    },
    schema: {
      backend: '/api/repos/schema/',
      frontend: `${frontendPrefix}schema/`,
    },
    attributes: {
      backend: '/api/attributes/attributes/',
      frontend: `${frontendPrefix}attributes/`,
    },
    realty: {
      backend: '/api/realty/realty/',
      frontend: `${frontendPrefix}realty/`,
      useHierarchyPagination: true,
    },
    lands: {
      backend: '/api/realty/lands/',
      frontend: `${frontendPrefix}lands/`,
    },
    householdMembers: {
      backend: '/api/household/members/',
      frontend: `${frontendPrefix}householdMembers/`,
    },
    easements: {
      backend: '/api/realty/easements/',
      frontend: `${frontendPrefix}easements/`,
    },
    sessiondecision: {
      backend: '/api/realty/sessiondecisions/',
      frontend: `${frontendPrefix}sessiondecisions/`,
    },
    landcertificate: {
      backend: '/api/realty/landcertificate/',
      frontend: `${frontendPrefix}landcertificate/`,
    },
    percentForTaxLand: {
      backend: '/api/catalog/percentvalue/',
      frontend: `${frontendPrefix}percentvalue/`,
    },
  },
);

export default catalogs;
